import React, { Component } from "react";
import {
	View,
	StyleSheet,
	TextInput,
	Alert,
	Platform,
	Image,
	TouchableOpacity,
	Linking,
	Switch,
	ListView,
	Text,
} from "react-native";
import { NavigationActions } from "react-navigation";
import { translate } from "react-i18next";

import AWS from "aws-sdk/dist/aws-sdk-react-native";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";

// this API only mock data retrieval
import { addDevice, getAllDevices, getCurrentUserDevices } from "api";
import { push, reset } from "utils/navigation";
import ViewScroll from "components/ViewScroll";
import Header from "components/Header";
import Button from "components/Button";
import Textfield from "components/Textfield";
import Select from "components/Select";

import * as x from "../../styles/css";

const ADD = 'Add';
const EDIT = 'Edit';

class AddDevice extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;

	constructor(props) {
		super(props);
		const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});

		this.state = {
			deviceIdAdd: "",
			friendlyName: "",
			dataSource: ds,
			dataFromApi: null,
			allDeviceList: [],
			loading: false,
			isFormOpen: false,
			mode: ADD
		}
	}

	async componentDidMount() {
		console.log("AddDevice - componentDidMount")
		this.setState({
			allDeviceList: await getCurrentUserDevices()
		},() => {
			this.setState({
				dataSource: this.state.dataSource.cloneWithRows(this.state.dataFromApi)
			})
		});
	}

	handleTextChange = (value) => {
		console.log("AddDevice - handleTextChange")
		const friendlyName = value;
		this.setState(() => ({
			friendlyName
		}));
		}

	handleAddNewDevice = () => {
		console.log("AddDevice - handleAddNewDevice")
		this.setState({
			deviceIdAdd: "",
			friendlyName: "",
			isFormOpen: true,
			mode: ADD
		});
	}

	handleAddDevice = () => {

		// NOTE: add device or edit must be done here
		// addDevice(deviceId).catch(err => {
		// 	console.log(err);
		// 	window.alert("Unable to add device", err);
		// 	push(
		// 		{
		// 			web: "/",
		// 			mobile: "Home",
		// 		},
		// 		this.props
		// 	);
		// });

		this.setState({ isFormOpen: false });
	}

	handleEditDevice = (data) => {
		console.log(data);
		this.setState({
			deviceIdAdd: data.deviceId,
			friendlyName: data.friendlyName,
			isFormOpen: true,
			mode: EDIT
		});
	}

	handleDeleteButtonPress = (id) => {
		this.setState((a) => {
			const newItem = a.dataSource._dataBlob.s1.filter((item, i) => (parseInt(id) !== i));
			return {
				dataSource: this.state.dataSource.cloneWithRows(newItem)
			}
		})
	};

	closeDeviceForm = () => {
		this.setState({ isFormOpen: false });
	}

	goBack = () => {
		push({ mobile: "Home", web: "/" }, this.props, true);
	}

	render() {
		const { t } = this.props;

		return (
			<ViewScroll>
				<View style={[x.mb.three]}>
					<Header>{t("labels.addDevice")}</Header>
				</View>

				{(this.state.isFormOpen)
				?
					<View style={[x.my.three]}>
						<Select
							native
							label={t("labels.deviceId")}
							onChange={state =>
								this.setState({
									deviceIdAdd: state.target.value,
								})
							}
							onChangeText={state =>
								this.setState({
									deviceIdAdd: state.target.value,
								})
							}
							value={this.state.deviceIdAdd}
							data={this.state.allDeviceList}
						/>
						<Textfield
							label={t("labels.friendlyName")}
							value={this.state.friendlyName}
							onChangeText={this.handleTextChange}
						/>
						<Button
							disabled={this.state.loading}
							title={(this.state.mode === ADD) ? t("labels.addDevice") : t("labels.editDevice")}
							color={x.colors.default}
							onPress={this.handleAddDevice}
						/>
						<Button
							disabled={this.state.loading}
							onPress={this.closeDeviceForm}
							title={t("labels.cancel")}
							color={"#A1D9DA"}
						/>
					</View>
				:

					<View style={[x.mt.three]}>
						<Text style={styles.subTitle}>Your devices</Text>
						<ListView
							style={styles.listView}
							dataSource={this.state.dataSource}
							enableEmptySections={true}
							renderRow={(rowData, sectionID, rowID) => {
								const handleDelete = () => {
									return this.handleDeleteButtonPress(rowID);
								}
								return (
								<View style={styles.rowItem}>
									<Text style={styles.rowText}>{rowData.deviceId}</Text>
									<Text style={styles.rowText}>{rowData.friendlyName}</Text>
									<Button
										style={styles.rowText}
										title={t("labels.edit")}
										color={x.colors.default}
										onPress={() => this.handleEditDevice(rowData)}
									/>
									<Button
										style={[styles.rowText, styles.deleteBtn]}
										title={t("labels.delete")}
										color={x.colors.default}
										onPress={handleDelete}
									/>
								</View>
								);
								}
							}
						/>
						<Button
							disabled={this.state.loading}
							onPress={this.handleAddNewDevice}
							title={t("labels.addNewDevice")}
							color={x.colors.default}
						/>
						<Button
							disabled={this.state.loading}
							onPress={this.goBack}
							title={t("labels.back")}
							color={"#A1D9DA"}
							style={styles.backBtn}
						/>
					</View>
				}
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	body: {
		backgroundColor: "white",
	},
	scrollView: {
		marginBottom: 20,
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		backgroundColor: "white",
	},
	background: {
		backgroundColor: "#fff",
		...(Platform.OS === "web"
			? { maxHeight: 600, minHeight: 500, width: "100%" }
			: {}),
	},
	rowItem: {
		alignItems: 'center',
		padding: 8,
		width: 760,
		justifyContent: 'center',
		borderBottomWidth: 1.5,
		borderColor: '#e0e0e0',
		backgroundColor: '#fff',
		// borderWidth: '1 solid #333',
		flex: 1,
		flexDirection: 'row',
	},
	rowText:{
		flex: 1,
		margin: 5
	},
	deleteBtn: {
		backgroundColor: '#EB5F07'
	},
	subTitle: {
		color: '#4DB6AC',
		fontSize: 20,
		fontWeight: 'bold'
	},
	backBtn: {
		marginTop: 5
	}
});

export default translate()(AddDevice);



// WEBPACK FOOTER //
// ./src/views/AddDevice/index.js